import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = exact({
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
  noResultsMessage: PropTypes.string.isRequired,
});

function Result(props) {
  return (
    <div className="SearchResults">
      {props.items.map((item) => (
        <article key={item.key} className="SearchResult">
          <a href={item.url} className="SearchResult_title">
            {item.title}
          </a>
        </article>
      ))}
      {props.items.length < 1 && (
        <div className="SearchResult_noResults">{props.noResultsMessage}</div>
      )}
    </div>
  );
}

Result.propTypes = propTypes;

export default Result;
